export enum DocumentCategory {
  CIVIL = "Civil",
  MECHANICAL = "Mechanical",
  ELECTRICAL = "Electrical",
  INSTRUMENTATION = "Instrumentation"
}
